import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {Screens} from '../../shared/routing/model';
import {Route, useNavigation} from '@react-navigation/native';
import {contentSelector} from '../../redux/selectors/resources';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {UscType} from '../../shared/models/profile/uscType';

export const TransportServicesScreen = ({route}: {route: Route<string>}) => {
  const navigation = useNavigation();
  const holderProfile = useSelector(holderProfileSelector());
  const content = useSelector(contentSelector());

  if (holderProfile && holderProfile.uscIsBlocked) {
    navigation.navigate(Screens.Main);
    return null;
  }

  return (
    <View
      content={content}
      route={route}
      isFinancialCard={holderProfile && holderProfile.uscType === UscType.Financial}
    />
  );
};
